import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const trustedAdvisorStressFeatures: LandingPageFeature[] = [
  {
    id: 'daytime_stress',
    title: 'stress_features_title_1',
    description: 'stress_features_copy_1',
    image: {
      format: 'svg',
      localizedAlt: 'stress_app_ui_daytime_alt',
      localizedSrc: 'stress_app_ui_daytime',
    },
  },
  {
    id: 'resilience',
    title: 'stress_features_title_2',
    description: 'stress_features_copy_2',
    image: {
      format: 'svg',
      localizedAlt: 'stress_app_ui_resilience_alt',
      localizedSrc: 'stress_app_ui_resilience',
    },
  },
  {
    id: 'cumulative_stress',
    title: 'cumulative_stress_feature_title',
    description: 'cumulative_stress_feature_copy',
    image: {
      format: 'png',
      localizedAlt: 'cumulative_stress_app_ui_alt',
      localizedSrc: 'cumulative_stress_app_ui',
      className: 'object-contain max-w-[60%] justify-self-center',
    },
  },
];

export default trustedAdvisorStressFeatures;
